﻿import React from 'react';
import ProfileMenuItems from './ProfileMenuItems.jsx';
import './styles/ProfileMenu.css';
import PropTypes from "prop-types";

export default function ProfileMenu({ profileMenuVisible, setProfileMenuVisible }) {
    function onProfileMenuClick() {
        setProfileMenuVisible(!profileMenuVisible)
        document.body.onmousedown = document.body.touchStart = function(e) {
            if (e.target.closest('.header__profile-menu') === null) {
                setProfileMenuVisible(false);
            }

            document.body.onmousedown = document.body.touchStart = null;
        }
    }


    return (
        <div className={`header__profile-menu ${profileMenuVisible ? 'visible' : ''}`}>
            <button className="header__profile-button" onClick={onProfileMenuClick}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="white" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>

            {profileMenuVisible && (
                <div className="header__profile-dropdown">
                    <ProfileMenuItems onItemClick={() => setProfileMenuVisible(false)}/>
                </div>
            )}
        </div>
    );
}

ProfileMenu.propTypes = {
    profileMenuVisible: PropTypes.bool,
    setProfileMenuVisible: PropTypes.func,
};

